// extracted by mini-css-extract-plugin
module.exports =  {"TooltipIcon":"TooltipIcon__XsD0X"};